import React from 'react';
import { Badge } from 'reactstrap';

// Distinct styling per approval-request status.
const COLORS = {
  pending: 'warning',
  approved: 'info',
  executed: 'success',
  denied: 'danger',
  failed: 'danger',
  expired: 'secondary',
};

export default ({ status }) => {
  const key = (status || '').toLowerCase();
  return (
    <Badge color={COLORS[key] || 'secondary'}>
      {(status || 'unknown').toUpperCase()}
    </Badge>
  );
};
